module.exports = __webpack_public_path__ + "static/img/Jack-de-Belin.8df1ef6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-de-Belin.jpg
// module id = fiDG
// module chunks = 0